import Login from './Login'

export default Login



// WEBPACK FOOTER //
// ./src/components/Login/index.js